export const TOP_INCUT_CONTENT_CONSTS = {
  approveSaveChangesQuestion:
    'Есть несохраненные изменения, сначала сохраните их, имейте ввиду что блок без фотографии сохраниться не может',
  approveSaveChangesQuestion2: 'Вы действительно хотите уйти со страницы? Внесенные изменения не будут сохранены!',
  blockHistoryMsg: 'История изменений',
  blockWasSavedMsg: 'Блок создан',
  cancelChangesConfirmation: 'Отменить изменения',
  errorMsg: 'Ошибка',
  revertDeleteMsg: 'Отменить удаление',
  saveChangesMsg: 'Сохранить изменения',
  saveMsg: 'Сохранить врезки',
  savedMsg: 'Врезки сохранены',
  warning: 'Внимание!',
  withoutIncutsTitle: 'Врезки отстутствуют',
  withoutIncutsDescription: 'Добавьте врезки, чтобы они появлись на сайте'
}
